import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
const baseUrlQny = 'https://light.taiott.com/v1'
export default {
	/**
	 * 摄像头列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	cameraList( params={} ) {
		return request({
	    url: baseUrl + '/device/camera',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 摄像头添加
	**/
	cameraAdd(data){
		return request({
			url: baseUrl + '/device/camera',
			method:'POST',
			data
		})
	},

	/**
	 * 摄像头详情
	**/
	cameraInfo(data){
		return request({
			url: baseUrl + '/device/getCameraInfo',
			method:'POST',
			data
		})
	},

	/**
	 * 摄像头设为首页
	**/
	cameraSetHome(id,data){
		return request({
			url: baseUrl + '/device/SetCamera/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 摄像头编辑
	**/
	cameraEdit(id,data){
		return request({
			url: baseUrl + '/device/camera/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 摄像头删除
	**/
	cameraDel(id){
		return request({
			url: baseUrl + '/device/camera/'+id,
			method:'DELETE'
		})
	},


	/**
	 * 获取萤石云token
	 * @return {object}
	**/
	getAccessToken() {
		return request({
		url: baseUrl + '/public/getAccessToken',
	    method: 'get'
	  })
	},

	/**
	 * 大华摄像头控制
	 * 参数  operation 	0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-放大，9-缩小，10-停止
	 * @return {object}
	**/
	dhControlPTZ(data) {
		return request({
		url: baseUrl + '/device/ControlPTZ',
	    method: 'post',
		data
	  })
	},

	/**
	 * 七牛-张豹 获取静态拉流地址
	**/
	qnyJavaGetStreamUrl( params={} ) {
		return request({
	    url: baseUrlQny + '/videoMonitor/getStaticStreamAddress',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 七牛-张豹 启动设备拉流
	**/
	qnyJavaStartFlow() {
		return request({
		url: baseUrlQny + '/videoMonitor/pullFlow',
		method: 'POST'
	  })
	},
	
	/**
	 * 七牛-张豹 停止设备拉流
	**/
	qnyJavaStopFlow() {
		return request({
		url: baseUrlQny + '/videoMonitor/stopFlow',
		method: 'POST'
	  })
	},

	/**
	 * 七牛-张豹 PTZ云端控制
	 *  @param   	cmd  控制  ( left(向左), right(向右), up(向上), down(向下), leftup(左上)
               ,rightup(右上), leftdown(左下), rightdown(右下), zoomin(缩小)
               ,zoomout(放大),stop(停止PTZ操作) ) 
		@param   	speed 调节速度 (1-10, 默认位5)
		@return 	code msg
```
	**/
	qnyJavaVideoControl(data) {
		return request({
		url: baseUrlQny + '/videoMonitor/cloudPTZControl',
		method: 'POST',
		data
	  })
	},

	/**
	 * 七牛-php 获取静态拉流地址
	**/
	qnyGetStreamUrl(number) {
		return request({
	    url: baseUrl + '/device/getCameraStreams/'+number,
	    method: 'GET'
	  })
	},

	/**
	 * 七牛-php 推拉流
	 * type 0关闭 1开启
	**/
	qnyFlow(number,data) {
		return request({
		url: baseUrl + '/device/setCameraStreams/'+number,
		method: 'POST',
		data
	  })
	},

	/**
	 * 摄像头PTZ控制
	 * @param  number 	摄像头编号
	 * @param  operation 	0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-放大，9-缩小，10-停止
	 * @param   	speed 调节速度 (1-10, 默认位5)
	 * @return {object}
	**/
	videoControl(data) {
		return request({
		url: baseUrl + '/device/ControlPTZ',
	    method: 'post',
		data
	  })
	}
}